export default {
  SET_STATE: 'analytics/SET_STATE',
  FETCH_SUBSCRIPTIONS: 'analytics/FETCH_SUBSCRIPTIONS',
  FETCH_POST_ANALYTICS: 'analytics/FETCH_POST_ANALYTICS',
  FETCH_REVENUE_ANALYTICS: 'analytics/FETCH_REVENUE_ANALYTICS',
  FETCH_LAST_MONTH_STATS: 'analytics/FETCH_LAST_MONTH_STATS',
}
